import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=b209b622&scoped=true&"
import script from "./slider.vue?vue&type=script&lang=ts&"
export * from "./slider.vue?vue&type=script&lang=ts&"
import style0 from "./slider.vue?vue&type=style&index=0&id=b209b622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b209b622",
  null
  
)

export default component.exports